import "./ChemometricModelDevelopment.module.css";
import Header from "@/reusable_sections/Header";
import ChemometricHero from "./sections/ChemometricHero";
import Capabilities from "./sections/Capabilities";
import PatSolutions from "./sections/PatSolutions";
import Servicenavigation from "./sections/Servicenavigation";
import ConsultationContact from "./sections/ConsultationContact";
import Footer from "@/reusable_sections/Footer";
export default function ChemometricModelDevelopmentPage() {
  return <div>
      <Header />
      <ChemometricHero />
      <Capabilities />
      <PatSolutions />
      <Servicenavigation />
      <ConsultationContact />
      <Footer />
    </div>;
}